import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WindPowerIcon(props: IconProps) {
    return <Icon {...props} iconKey={"wind_power"}/>
}
